import { TApplicationState } from '../../types/redux';

export const selectFormPhoneError = (state: TApplicationState) => state.requestFormV2.errors.phone;
